import React, { Component } from "react";

export default class money_card extends Component {
  render() {
    return (
      <div
        className={
          "card-container" +
          " " +
          (this.props.className ? this.props.className : "")
        }
      >
        <div className="card">
          <p className="title">{this.props.title}</p>
          <p className="cash">{this.props.value}</p>
          {/* <p className="key-value">
            <span className="value">15</span>
            <span className="key">Bookings</span>
          </p> */}
        </div>
      </div>
    );
  }
}
